export default __webpack_public_path__ + "static/media/invite.fcfd3ffe.png";